import { IWorkDay } from 'owa-scheduling-hours';
import { OwaDate } from 'owa-datetime';

export interface ProfileEditState {
    id: string;
    name: string;
    description: string;
    availability: AvailabilityState;
    hasError: boolean;
    showErrorMessage: boolean;
    recipientErrorDetails: string[];
}

export interface AvailabilityState {
    availabilityType?: AvailabilityType;
    isDateRestricted?: boolean;
    startDate?: OwaDate;
    endDate?: OwaDate;
    isTimeRestricted?: boolean;
    customHours?: IWorkDay[];
    isDirty?: boolean;
}

export enum AvailabilityType {
    Undefined = 0,
    DefaultSetup = 1,
    NotBookable = 2,
    Custom = 3,
}

export default ProfileEditState;
